var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-with-sidebar"},[_c('div',{staticClass:"main-box"},[_vm._t("main")],2),_c('div',{staticClass:"sidebar-box"},[_vm._t("sidebar")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }